// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2741":"fc89c306cdedda27","4425":"5bf2b2f415534df9"}[chunkId] + ".css";
};